/**
 * Метод загрузки стиля модуля для добаления темы яндекс карт
 * @kind helper
 * @returns Промис получения пакета
 */
export const loadDefaultUITheme = () =>
    import(/* webpackChunkName: "ymaps3-default-ui-theme" */ '@yandex/ymaps3-default-ui-theme');
